module.exports = __webpack_public_path__ + "static/media/vectors-03.2d62924d.png";